import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, TimeTrackingAclKeys, withPermission } from '@/lib/acl';

/**
 * Segment layout for `/time` — gates the whole time-tracking subtree (logs, timesheets, time off,
 * leave policies, holiday calendars) behind `time:module:read` via a single gated Outlet.
 *
 * One namespace rather than three siblings (`/time-logs`, `/time-off`, `/team-overview` in the
 * source app): entite-web's sidebar is a flat single-level list, so three top-level entries for one
 * domain would be the only such case — and the source's own sidebar already groups them under one
 * "Time tracking" header.
 *
 * Fail-closed by construction: `withPermission` renders the gated Outlet only once the key set has
 * resolved AND contains the key. While loading it renders the fallback, never the gated UI.
 */
export const Route = createFileRoute('/time')({
  component: withPermission(Outlet, {
    key: TimeTrackingAclKeys.moduleRead,
    route: AclRoute.TIME_TRACKING,
    resourceLabel: 'Time tracking',
  }),
});
